import { APP_BANNER_LOCALE_ID } from '../constants';

/** Single definition for UK-only behaviour (currently the app banner). */
export function isUkShopper(localeId: string | undefined): boolean {
    return localeId?.toLowerCase() === APP_BANNER_LOCALE_ID.toLowerCase();
}
